import React from "react";

export function Youtube({ youtube }) {
  if (youtube !== "" && youtube.videos !== []) {
    return (
      <>
        <h3 className="mx-2 my-4">Youtube Posts</h3>
        {youtube.videos.map((data, index) => {
          return (
            <a key={index} href={"https://youtube.com" + data.url_suffix} target="_blank" rel="noreferrer">
              <div key={index} className="block text-secondary d-sm-flex">
                <img
                  src={data.thumbnails[0]}
                  className="col-12 col-sm-4"
                  alt={index + "s"}
                ></img>
                <div className="p-2 col-12 col-sm-8">
                  <p className="font-weight-bold"><i className="fab fa-youtube text-6xl text-danger"></i> {data.channel}</p>
                  <p>{data.title}</p>
                  <p>{data.long_desc}</p>
                  <div className="font-smaller justify-content-between">
                    <p><i className="far fa-clock"></i> {data.duration}</p>
                    <p><i className="far fa-eye"></i> {data.views}</p>
                  </div>
                </div>
              </div>
              <hr className="bg-secondary"></hr>
            </a>
          );
        })}
      </>
    );
  } else {
    return "";
  }
}

// export function Reddit({ reddit }) {
//   if (reddit !== "" && reddit.error !== "Too Many Requests") {
//     return (
//       <>
//         <h3 className="text-center">Reddit Posts</h3>
//         {reddit.authorFlair.posts.map((data, index) => {
//           return (
//             <div key={index}>
//               <h5>{data.author}</h5>
//               <p>{data.title}</p>
//             </div>
//           );
//         })}
//       </>
//     );
//   } else {
//     return "";
//   }
// }

function Socials({ youtube }) {
  return (
    <div className="bg-light py-2 px-3 px-sm-3">
      <Youtube youtube={youtube} />
      {/* <Reddit reddit={reddit} /> */}
    </div>
  );
}

export default Socials;
